import { render, staticRenderFns } from "./textova-predpoved.vue?vue&type=template&id=542e73e1&"
import script from "./textova-predpoved.vue?vue&type=script&lang=js&"
export * from "./textova-predpoved.vue?vue&type=script&lang=js&"
import style0 from "./textova-predpoved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports